import { HttpContextToken } from "@angular/common/http";

export const BYPASS_LOG = new HttpContextToken(() => false);